export const en = {
  siteName: 'TudoConversor',
  siteTagline: 'Free Online Unit Converter',
  siteDescription: 'Convert length, weight, temperature, speed, area, volume and 65+ unit types. Free, fast and accurate online calculator. No registration.',
  nav: {
    home: 'Home',
    about: 'About',
    contact: 'Contact',
    imcCalc: 'BMI Calculator',
    categories: 'Categories',
    converters: 'Converters',
    backToHome: 'Back to home',
    mainNav: 'Main navigation',
    mobileNav: 'Mobile navigation',
    openMenu: 'Open navigation menu',
    menuTitle: 'Navigation Menu',
    categoryConverters: 'Converter Categories',
    viewCategory: 'View category converters'
  },
  footer: {
    tagline: 'The ultimate conversion platform. Accurate, fast, and free calculations for engineering, science, and everyday use.',
    toolsAndCategories: 'Tools & Categories',
    commonConverters: 'Common Converters',
    engineeringPhysics: 'Engineering & Physics',
    electricity: 'Electricity',
    imcCalculator: 'BMI Calculator',
    pressureConverter: 'Pressure Converter',
    energyConverter: 'Energy Converter',
    converters: 'Converters',
    length: 'Length',
    temperature: 'Temperature',
    weight: 'Weight',
    volume: 'Volume',
    area: 'Area',
    speed: 'Speed',
    time: 'Time',
    digitalData: 'Digital Data',
    navigation: 'Navigation',
    homePage: 'Home Page',
    resourcesArticles: 'Resources & Articles',
    aboutUs: 'About TudoConversor',
    contact: 'Contact',
    legal: 'Legal',
    privacyPolicy: 'Privacy Policy',
    termsOfService: 'Terms of Service',
    dataProtection: 'Data Protection',
    cookiesPolicy: 'Cookies Policy',
    legalNotice: 'Legal Notice',
    copyright: 'All rights reserved.',
    builtFor: 'Built for maximum precision.',
    footerLabel: 'Site footer'
  },
  cookie: {
    title: 'Cookies and Privacy Notice',
    description: 'We use cookies to personalize content, ads, and improve your experience. By continuing to browse, you agree to the use of these technologies according to our ',
    cookiesPolicy: 'Cookies Policy',
    accept: 'Accept cookies',
    reject: 'Decline'
  },
  converter: {
    category: 'Category',
    selectCategory: 'Select Category',
    converter: 'Converter',
    selectConverter: 'Select Converter',
    value: 'Value',
    result: 'Result',
    from: 'From',
    to: 'To',
    fromUnit: 'Source unit',
    toUnit: 'Target unit',
    swap: 'Swap units'
  },
  home: {
    heroTitle: 'The Most Complete Unit Converter',
    heroContent: 'Accurate, instant, and free calculations. Support for over 72 converters covering physics, engineering, computing, and everyday measurements.',
    top10: 'Top 10 Most Accessed Converters',
    allConverters: 'All Converters',
    exploreTools: 'Explore Our 72+ Tools',
    faqTitle: 'Frequently Asked Questions',
    howItWorksTitle: 'How Unit Conversion Works',
    siSystem: 'International System of Units (SI)',
    and: 'and the',
    bipm: 'International Bureau of Weights and Measures (BIPM)',
    mostSearched: 'Most Searched Conversions',
    converters: {
      length: 'Length',
      temperature: 'Temperature',
      weight: 'Weight & Mass',
      volume: 'Volume',
      area: 'Area',
      speed: 'Speed',
      time: 'Time',
      pressure: 'Pressure',
      energy: 'Energy',
      density: 'Density',
      torque: 'Torque',
      digitalData: 'Digital Data',
      dataTransfer: 'Data Transfer',
      voltage: 'Voltage',
      fuelConsumption: 'Fuel Consumption',
      luminance: 'Luminance',
      viscosity: 'Viscosity',
      frequency: 'Frequency',
      imcCalc: 'BMI Calculator',
      shoeSize: 'Shoe Size'
    },
    popular: {
      lengthDesc: 'm, km, miles, feet',
      weightDesc: 'kg, lb, grams, oz',
      temperatureDesc: 'Celsius, Fahrenheit, K',
      volumeDesc: 'Liters, gallons, m³',
      speedDesc: 'km/h, mph, knots',
      areaDesc: 'm², hectares, acres',
      voltageDesc: 'V, mV, kV',
      accelerationDesc: 'm/s², km/h²',
      densityDesc: 'kg/m³, g/cm³',
      timeDesc: 'Seconds, Hours, Days'
    }
  },
  converterPage: {
    quickConversions: 'Quick Conversions',
    relatedConverters: 'Related Converters'
  },
  categoryPage: {
    availableConverters: 'Available Converters',
    exploreCategory: 'Explore Category'
  },
  unitPair: {
    converterTitle: 'Converter',
    instantFree: 'Instant and Free',
    typeBelow: 'Enter the value below to convert',
    faqTitle: 'Frequently Asked Questions',
    backToConverter: 'Back to main converter',
    faq1Title: 'How to convert?',
    faq1Answer: 'Just type the value in the source field and the result will appear automatically.',
    faq2Title: 'Is the conversion exact?',
    faq2Answer: 'Yes, we use official unit conversion definitions to ensure maximum precision.',
    faq3Title: 'Can I swap the units?',
    faq3Answer: 'Yes, use the button with the arrows to reverse the conversion direction.',
    faq4Title: 'Is it free?',
    faq4Answer: 'Completely free, with no usage limits or registration required.'
  },
  notFound: {
    title: 'Page Not Found',
    message: 'The page you are looking for does not exist or has been moved.',
    backHome: 'Back to Home'
  },
  about: {
    title: 'About TudoConversor',
    forWho: 'Who is it for?',
    user1: 'Students',
    user2: 'Professionals',
    user3: 'Everyday Use',
    precision: 'Our Commitment to Precision',
    questions: 'Have any questions?',
    usefulPages: 'Useful Pages',
    backToConverter: 'Back to Converters',
    contactUs: 'Contact Us'
  },
  contact: {
    title: 'Get in Touch',
    successTitle: 'Message Sent!',
    fullName: 'Full Name',
    email: 'Email',
    message: 'Your Message',
    responseTime: 'We reply within 24 hours',
    helpTopics: 'Help Topics',
    about: 'Tool questions',
    faq: 'FAQ',
    faqDesc: 'View our help section',
    transparency: 'Transparency and Trust',
    usefulPages: 'Useful Links',
    backToConverter: 'Back to Converters',
    privacyPolicy: 'Privacy Policy',
    send: 'Send Message'
  },
  imc: {
    title: 'BMI Calculator',
    weight: 'Weight (kg)',
    height: 'Height (cm)',
    sex: 'Sex',
    male: 'Male',
    female: 'Female',
    calculate: 'Calculate BMI',
    yourResult: 'Your Result',
    hide: 'Hide',
    referenceTable: 'Reference Table',
    underweight: 'Underweight',
    normal: 'Normal weight',
    overweight: 'Overweight',
    obese1: 'Obesity Class I',
    obese2: 'Obesity Class II',
    obese3: 'Obesity Class III',
    below185: 'Below 18.5',
    range185: '18.5 to 24.9',
    range250: '25.0 to 29.9',
    range300: '30.0 to 34.9',
    range350: '35.0 to 39.9',
    above400: 'Above 40.0',
    description: 'Easily calculate your Body Mass Index (BMI).'
  },
  resources: {
    title: 'Resources and Articles',
    metricVsImperial: 'Metric vs Imperial System',
    temperatureGuide: 'Temperature Scales Guide',
    electricityGuide: 'Electrical Units Fundamentals',
    goToLengthConverter: 'Go to Length Converter',
    goToTempConverter: 'Go to Temperature Converter'
  },
  seo: {
    homeTitle: 'TudoConversor | The Most Complete Unit Converter',
    homeDescription: 'Convert units of length, weight, temperature, area and over 65 categories at TudoConversor. Free, fast tool with scientific precision.',
    aboutTitle: 'About Us | TudoConversor',
    contactTitle: 'Contact | TudoConversor',
    imcTitle: 'Free Online BMI Calculator | TudoConversor',
    imcDescription: 'Calculate your Body Mass Index (BMI) with our accurate online tool. See your classification in the WHO reference table.',
    resourcesTitle: 'Resources & Guides | TudoConversor',
    notFoundTitle: 'Page Not Found | TudoConversor',
    converterTitle: 'Unit Converter',
    converterDescription: 'Free online tool for unit conversion.',
    categoryTitle: 'Conversion Category',
    unitPairDescription: 'Convert units instantly for free.'
  },
  categories: {
    common: 'Common',
    engineering: 'Engineering',
    heat: 'Heat',
    fluids: 'Fluids',
    light: 'Light',
    electricity: 'Electricity',
    magnetism: 'Magnetism',
    radiology: 'Radiology',
    other: 'Other',
    currency: 'Currency'
  },
  units: {
    length: 'Length',
    meter: 'Meter',
    kilometer: 'Kilometer',
    centimeter: 'Centimeter',
    millimeter: 'Millimeter',
    mile: 'Mile',
    yard: 'Yard',
    foot: 'Foot',
    inch: 'Inch',
    temperature: 'Temperature',
    celsius: 'Celsius',
    fahrenheit: 'Fahrenheit',
    kelvin: 'Kelvin',
    weight: 'Weight & Mass',
    kilogram: 'Kilogram',
    gram: 'Gram',
    milligram: 'Milligram',
    ton: 'Ton',
    pound: 'Pound',
    ounce: 'Ounce',
    volume: 'Volume',
    area: 'Area',
    time: 'Time',
    speed: 'Speed',
    shoeSize: 'Shoe Size',
    density: 'Density',
    angularVelocity: 'Angular Velocity',
    acceleration: 'Acceleration',
    angularAcceleration: 'Angular Acceleration',
    specificVolume: 'Specific Volume',
    momentOfInertia: 'Moment of Inertia',
    torque: 'Torque',
    pressure: 'Pressure',
    energy: 'Energy',
    fuelEfficiency: 'Fuel Efficiency',
    fuelConsumption: 'Fuel Consumption',
    cooking: 'Cooking Measurements',
    pace: 'Running Pace',
    temperatureInterval: 'Temperature Interval',
    thermalExpansion: 'Thermal Expansion',
    thermalResistance: 'Thermal Resistance',
    thermalConductivity: 'Thermal Conductivity',
    specificHeatCapacity: 'Specific Heat Capacity',
    thermalEnergyDensity: 'Thermal Energy Density',
    heatFluxDensity: 'Heat Flux Density',
    heatTransferCoefficient: 'Heat Transfer Coefficient',
    volumetricFlow: 'Volumetric Flow Rate',
    massFlow: 'Mass Flow Rate',
    molarFlow: 'Molar Flow Rate',
    massFluxDensity: 'Mass Flux Density',
    molarConcentration: 'Molar Concentration',
    solutionConcentration: 'Solution Concentration',
    dynamicViscosity: 'Dynamic Viscosity',
    kinematicViscosity: 'Kinematic Viscosity',
    surfaceTension: 'Surface Tension',
    permeability: 'Permeability',
    luminance: 'Luminance',
    luminousIntensity: 'Luminous Intensity',
    illumination: 'Illumination',
    digitalImageResolution: 'Digital Image Resolution',
    frequency: 'Frequency',
    charge: 'Electric Charge',
    current: 'Electric Current',
    voltage: 'Voltage',
    linearChargeDensity: 'Linear Charge Density',
    surfaceChargeDensity: 'Surface Charge Density',
    volumeChargeDensity: 'Volume Charge Density',
    linearCurrentDensity: 'Linear Current Density',
    surfaceCurrentDensity: 'Surface Current Density',
    electricFieldStrength: 'Electric Field Strength',
    resistance: 'Electrical Resistance',
    electricalResistivity: 'Electrical Resistivity',
    conductance: 'Electrical Conductance',
    electricalConductivity: 'Electrical Conductivity',
    capacitance: 'Capacitance',
    inductance: 'Inductance',
    magnetomotiveForce: 'Magnetomotive Force',
    magneticFieldIntensity: 'Magnetic Field Intensity',
    magneticFlux: 'Magnetic Flux',
    magneticFluxDensity: 'Magnetic Flux Density',
    radiation: 'Radiation',
    radiationActivity: 'Radiation Activity',
    radiationExposure: 'Radiation Exposure',
    absorbedDose: 'Absorbed Dose',
    dataStorage: 'Data Storage',
    dataTransfer: 'Data Transfer',
    typography: 'Typography',
    fluidFlow: 'Fluid Flow',
    concentration: 'Concentration',
    viscosity: 'Viscosity',
    electricalProperties: 'Electrical Properties',
    magneticProperties: 'Magnetic Properties',
    thermalProperties: 'Thermal Properties',
    other: 'Other Converters',
    currency: 'Currency Converter',
    angle: 'Angle',
    power: 'Power',
    force: 'Force',
    'sound-level': 'Sound Level',
    'clothing-size': 'Clothing Size',
    ppm: 'PPM (Parts per Million)',
    powerDbm: 'Power in dBm',
    scale: 'Scale',
    largeNumbers: 'Large Numbers',
    cupToGrams: 'Cup to Grams by Ingredient',
    numberBases: 'Number Bases (Binary, Decimal, Hexadecimal)',
    pixelsDpi: 'Pixels to Inches (DPI)',
    inchFraction: 'Inch Fraction to Decimal',
    colorConverter: 'Color Converter (HEX, RGB, HSL, CMYK)',
    timezone: 'Time Zone between Capitals'
  }
};